var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"userQuestionsComp"},[_c('tbl-comp',{attrs:{"model":this.$store.getters[`${this.moduleName}/getModel`],"paging":true,"rowClick":_vm.rowClick,"moduleName":_vm.moduleName,"searchInput":true,"btnAdd":false,"params":_vm.params}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }